"use client";

import { c as _c } from "react/compiler-runtime";
import { FiCheckCircle, FiArrowLeft, FiArrowRight, FiUsers } from "react-icons/fi";
const ReviewSubmitted = t0 => {
  const $ = _c(17);
  const {
    productName,
    selectedIndication,
    onViewProductPage,
    onRateAnotherIndication,
    isPipeline: t1
  } = t0;
  const isPipeline = t1 === undefined ? false : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-primary-primaryBlue flex items-center justify-center shadow-lg mb-4 sm:mb-6 mx-auto"><FiCheckCircle className="w-8 h-8 sm:w-10 sm:h-10 text-white" strokeWidth={2.5} /></div>;
    t3 = <h2 className="text-xl sm:text-3xl font-bold text-gray-900 font-poppins mb-3 sm:mb-4">Thank you for your insight!</h2>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== isPipeline || $[3] !== productName || $[4] !== selectedIndication) {
    t4 = <p className="text-sm sm:text-base text-gray-600 font-poppins mb-4 sm:mb-6 leading-relaxed">{isPipeline ? <>Your perspective on <span className="font-semibold text-gray-900">{productName || "this therapy"}</span> has been submitted.</> : <>Your review of <span className="font-semibold text-gray-900">{productName || "this product"}</span> for <span className="font-semibold text-gray-900">{selectedIndication || "No indication"}</span> has been submitted.</>}</p>;
    $[2] = isPipeline;
    $[3] = productName;
    $[4] = selectedIndication;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-6 sm:mt-10 w-full bg-blue-50 border border-blue-100 rounded-xl p-3 sm:p-4 flex items-center gap-2 sm:gap-3 text-left"><div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-blue-100 flex items-center justify-center"><FiUsers className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-blue-600" /></div><p className="text-xs sm:text-sm text-blue-600 font-medium font-poppins leading-relaxed">Your experience will help fellow prescribers make better treatment decisions</p></div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4) {
    t6 = <div className="flex-1 overflow-y-auto hide-scrollbar px-4 sm:px-6 py-6 sm:py-10 flex items-center justify-center"><div className="mx-auto text-center max-w-md">{t2}{t3}{t4}{t5}</div></div>;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== isPipeline || $[10] !== onRateAnotherIndication || $[11] !== onViewProductPage || $[12] !== productName) {
    t7 = !isPipeline && <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-white flex flex-col gap-2 sm:gap-3 flex-shrink-0"><div className="flex flex-col sm:flex-row gap-2 sm:gap-3"><button onClick={onViewProductPage} className="flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 hover:bg-gray-50 transition-colors flex items-center justify-center gap-2"><FiArrowLeft className="w-3.5 h-3.5 sm:w-4 sm:h-4" /><span className="truncate">Back to {productName || "Product"}</span></button><button onClick={onRateAnotherIndication} className="flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-md hover:shadow-lg transform hover:scale-[1.02] flex items-center justify-center gap-2"><span className="hidden sm:inline">Review Another Indication</span><span className="sm:hidden">Review Another</span><FiArrowRight className="w-3.5 h-3.5 sm:w-4 sm:h-4" /></button></div></div>;
    $[9] = isPipeline;
    $[10] = onRateAnotherIndication;
    $[11] = onViewProductPage;
    $[12] = productName;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default ReviewSubmitted;